import { useEffect, useState } from "react";
import { API_URL, use_store } from "../store";
import Button from "./button";
import Modal from "./modal";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";

export default function AccountPage({
  account_mode,
}: {
  account_mode: string;
}) {
  const {
    user,
    create_user,
    auth_user,
    email_token,
    delete_user,
    logout,
    update_user,
    start_loading,
    stop_loading,
    t,
    set_tool,
    set_message,
    token,
    ln,
    refresh_current_user,
    refresh_unique_data,
  } = use_store();
  const [email, set_email] = useState(user?.email || "");
  const [password, set_password] = useState("");
  const [account_management_mode, set_account_management_mode] =
    useState(account_mode);
  const [show_delete_modal, set_show_delete_modal] = useState(false);
  const [show_logout_modal, set_show_logout_modal] = useState(false);
  const [show_recovery_modal, set_show_recovery_modal] = useState(false);
  const [recovery_email, set_recovery_email] = useState("");
  const [expand_email, set_expand_email] = useState(false);

  // Email validation helper
  const is_valid_email = (email: string) => {
    const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return email_regex.test(email);
  };

  useEffect(() => {
    set_tool(undefined);
  }, []);

  useEffect(() => {
    if (user?.email && token) {
      set_account_management_mode("logged-in");
      set_email(user?.email || "");
      set_password("");
    }
  }, [user, token, ln]);
  console.log(account_mode, account_management_mode);

  const handle_google_login = () => {
    const auth_url = `${API_URL}/api/auth/google/login`;
    window.location.href = auth_url;
  };

  return (
    <>
    <div className="flex flex-col w-full items-center justify-start h-screen">
      {(account_management_mode === "create" ||
        account_management_mode === "login") && (
        <>
          {account_management_mode === "create" && (
            <>
              <p className="text-center mtitle mt-[48px] mb-[12px]">
                {t("Create a Lulu Loyal account to access all our features.")}
              </p>
              <p className="text-center vsmallt">
                {t("If you have an account, ")}
                <a className="text-brand-1 underline" href="/login">
                  {t("you can login by clicking here.")}
                </a>
              </p>
            </>
          )}
          {account_management_mode === "login" && (
            <>
              <p className="text-center mtitle mt-[48px] mb-[12px]">
                {t(
                  "Sign in to your Lulu Loyal account to access all our features.",
                )}
              </p>
              <p className="text-center vsmallt mb-[24px]">
                {t("Don't have an account?")}{" "}
                <a className="text-brand-1 underline" href="/account">
                  {t("Click here to create one.")}
                </a>
              </p>
            </>
          )}
          {account_management_mode == "create" && (
            <>
              <Button
                onClick={handle_google_login}
                secondary_style={true}
                className="mt-[24px] flex items-center justify-center gap-[8px]"
              >
                <p className="flex flex-row gap-[16px] justify-center items-center">
                  <span>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.845H13.8436C13.635 11.97 13.0009 12.9231 12.0477 13.5613V15.8195H14.9564C16.6582 14.2527 17.64 11.9454 17.64 9.20454Z"
                        fill="#4285F4"
                      />
                      <path
                        d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5614C11.2418 14.1014 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8373 3.96409 10.71H0.957275V13.0418C2.43818 15.9832 5.48182 18 9 18Z"
                        fill="#34A853"
                      />
                      <path
                        d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.95818H0.957273C0.347727 6.17318 0 7.54773 0 9C0 10.4523 0.347727 11.8268 0.957273 13.0418L3.96409 10.71Z"
                        fill="#FBBC05"
                      />
                      <path
                        d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
                        fill="#EA4335"
                      />
                    </svg>
                  </span>
                  <span className="">{t("Sign in with Google")}</span>
                </p>
              </Button>

              <div className="flex items-center justify-center flex-row w-full my-[24px]">
                <span className="px-[12px] eyebrows text-text-secondary">
                  {t("OR")}
                </span>
              </div>

              {!expand_email && (
                <Button
                  icon={faEnvelope}
                  secondary_style={true}
                  onClick={() => {
                    set_expand_email(true);
                    window.scrollTo(0, 300);
                  }}
                >
                  {t("Sign in with Email")}
                </Button>
              )}
            </>
          )}

          {(account_management_mode !== "create" || expand_email) && (
            <>
              <input
                placeholder={t("Email Address")}
                className="outline-none p-[16px] border-[1px] border-lines  w-full inputt bg-surface bg-surface focus:border-primary"
                value={email}
                type="email"
                autoComplete="email"
                onChange={(e) => {
                  set_email(e.target.value);
                }}
              ></input>

              <input
                placeholder={t("Password")}
                className="outline-none p-[16px] border-[1px] border-lines  w-full inputt bg-surface bg-surface mt-[12px] focus:border-primary mb-[12px]"
                value={password}
                type="password"
                autoComplete={account_management_mode === "create" ? "new-password" : "current-password"}
                onChange={(e) => {
                  set_password(e.target.value);
                }}
              ></input>
              <Button
                disabled={!is_valid_email(email) || password.length < 4}
                onClick={async () => {
                  if (account_management_mode === "create") {
                    start_loading(5000);
                    await create_user(email, password);
                    await refresh_current_user();
                    await refresh_unique_data();
                    window.location.href = ln ? `/${ln}/pay` : `/pay`;
                    stop_loading();
                  } else {
                    start_loading(5000);
                    await auth_user(email, password);
                    stop_loading();
                  }
                }}
              >
                {account_management_mode === "create"
                  ? t("Create Lulu Loyal Account")
                  : t("Log In To Lulu Loyal")}
              </Button>
            </>
          )}

          {account_management_mode === "login" && (
            <button
              className="mt-[12px] text-brand-1 underline smallt"
              onClick={() => set_show_recovery_modal(true)}
            >
              {t("Forgot Password?")}
            </button>
          )}
        </>
      )}
      {account_management_mode === "logged-in" && (
        <>
        {!user?.subscribed && (
                      <div className="w-full mb-[24px]">
                        <Button
                          secondary_style={false}
                          href={
                            ln
                              ? `/${ln}/pay`
                              : `/pay`
                          }
                        >
                          {t("Become Elite")}
                        </Button>
                      </div>
                    )}
          <p className="mtitle mb-[24px]">{t("My Account")}</p>
          <p className="samllt w-full text-left">{t("Change Email Address")}</p>

          <input
            placeholder={t("Email Address")}
            className="outline-none p-[16px] border-[1px] border-lines  w-full inputt bg-surface bg-surface mt-[12px] focus:border-primary"
            value={email}
            type="email"
            autoComplete="email"
            onChange={(e) => {
              set_email(e.target.value);
            }}
          ></input>

          <p className="samllt w-full text-left mt-[24px]">
            {t("Change Password")}
          </p>
          <input
            placeholder={t("Password")}
            className="outline-none p-[16px] border-[1px] border-lines  w-full inputt bg-surface bg-surface mt-[12px] focus:border-primary mb-[24px]"
            value={password}
            type="password"
            autoComplete="new-password"
            onChange={(e) => {
              set_password(e.target.value);
            }}
          ></input>

          <Button
            disabled={
              !is_valid_email(email) ||
              (password && password.length < 4) ||
              (email === user?.email && !password)
            }
            onClick={async () => {
              start_loading(5000);
              const update_data: any = {};

              // Only include email if it changed
              if (email && email !== user?.email) {
                update_data.email = email;
              }

              // Only include password if provided
              if (password) {
                update_data.password = password;
              }

              // Only call update if there are changes
              if (Object.keys(update_data).length > 0) {
                await update_user(update_data);
                set_password(""); // Clear password field after saving
                set_message(t("Account updated successfully."));
              }

              stop_loading();
            }}
          >
            {t("Save")}
          </Button>

          <div className="mt-[32px] mb-[32px] w-full h-[1px] bg-lines"></div>
          <Button
            secondary_style={true}
            href={"https://billing.stripe.com/p/login/4gMeVe1jX5WtbjJbwA4ko00"}
          >
            {t("Manage Subscription")}
          </Button>
          <div className="mt-[12px] flex flex-row gap-[12px] w-full">
            <div
              className="border-red-700 text-red cta flex-row justify-center items-center flex flex-1 text-red-700 flex-grow border-[1px] rounded-[4px] p-[20px] hover:bg-red-700/20 select-none cursor-pointer"
              onClick={() => set_show_logout_modal(true)}
            >
              {t("Logout")}
            </div>
            <div
              className="border-red-700 text-red cta flex-row justify-center items-center flex flex-1 text-red-700 flex-grow border-[1px] rounded-[4px] p-[20px] hover:bg-red-700/20 select-none cursor-pointer"
              onClick={() => set_show_delete_modal(true)}
            >
              {t("Delete Account")}
            </div>
          </div>
        </>
      )}

      <Modal
        is_open={show_delete_modal}
        on_close={() => set_show_delete_modal(false)}
      >
        <p className="mtitle mb-[16px]">{t("Confirm Delete")}</p>
        <p className="smallt mb-[24px]">
          {t(
            "Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.",
          )}
        </p>
        <div className="flex flex-row gap-[12px]">
          <div className="flex flex-1 flex-grow">
            <Button
              secondary_style={true}
              onClick={() => set_show_delete_modal(false)}
            >
              {t("Cancel")}
            </Button>
          </div>
          <div
            className="border-red-700 text-red cta flex-row justify-center items-center flex flex-1 text-red-700 flex-grow border-[1px] rounded-[4px] p-[20px] hover:bg-red-700/20 select-none cursor-pointer w-full"
            onClick={async () => {
              start_loading(5000);
              await delete_user();
              stop_loading();
            }}
          >
            {t("Delete Permanently")}
          </div>
        </div>
      </Modal>

      <Modal
        is_open={show_logout_modal}
        on_close={() => set_show_logout_modal(false)}
      >
        <p className="mtitle mb-[16px]">{t("Confirm Logout")}</p>
        <p className="smallt mb-[24px]">
          {t("Are you sure you want to logout?")}
        </p>
        <div className="flex flex-row gap-[12px]">
          <Button
            secondary_style={true}
            onClick={() => set_show_logout_modal(false)}
          >
            {t("Cancel")}
          </Button>
          <Button onClick={async () => await logout()}>{t("Logout")}</Button>
        </div>
      </Modal>

      <Modal
        is_open={show_recovery_modal}
        on_close={() => set_show_recovery_modal(false)}
      >
        <p className="mtitle mb-[16px]">{t("Password Recovery")}</p>
        <p className="smallt mb-[16px]">
          {t("Enter your email address to receive a login link.")}
        </p>
        <input
          placeholder={t("Email Address")}
          className="outline-none p-[16px] border-[1px] border-lines w-full inputt bg-surface mb-[16px] focus:border-primary"
          value={recovery_email}
          type="email"
          onChange={(e) => set_recovery_email(e.target.value)}
        />
        <div className="flex flex-row gap-[12px]">
          <Button
            secondary_style={true}
            onClick={() => set_show_recovery_modal(false)}
          >
            {t("Cancel")}
          </Button>
          <Button
            onClick={async () => {
              start_loading(5000);
              await email_token(recovery_email);
              stop_loading();
              set_show_recovery_modal(false);
              set_message(t("Recovery email sent. Please check your inbox."));
            }}
          >
            {t("Send Recovery Email")}
          </Button>
        </div>
      </Modal>
    </div>
    </>
  );
}
